// Keeps the page to return to across the redirect to Google and back (specs/12 FR-81). It's
// read and removed as soon as the app loads, so it's used at most once.

const KEY = "pokejournal.next";

function takeStored(): string | null {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path;
  } catch {
    return null;
  }
}

let pending = takeStored();

export function saveReturnPath(path: string) {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Without storage the person lands on the home page instead.
  }
}

/** The path saved before going to Google, if this page load is the return from there. */
export function takeReturnPath(): string | null {
  const path = pending;
  pending = null;
  return path;
}
